import clsx from "clsx";
import { NavLink, type NavLinkProps } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface Props extends Omit<NavLinkProps, "className"> {
  className?: string;
}

export const TopNavItem = ({ className, children, ...props }: Props) => (
  <NavLink
    className={({ isActive }) =>
      twMerge(
        clsx(
          "text-base font-semibold h-11 px-1 pt-2 text-v2-secondary",
          "no-underline relative text-v2-action group",
          {
            "bg-v2-primary shadow-[0px_0px_20px_0px_#0000001A]": isActive,
            "hover:bg-v2-primary opacity-60 hover:opacity-100": !isActive,
          },
        ),
        className,
      )
    }
    {...props}
  >
    {({ isActive }) => (
      <>
        <svg
          className={clsx(
            "absolute top-0 left-0.5 -translate-x-full group-hover:visible",
            {
              invisible: !isActive,
            },
          )}
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="47"
          viewBox="0 0 18 47"
          fill="none"
        >
          <path
            d="M18 47V0C12.4775 0 8 4.47754 8 10V38C8 42.418 4.41797 46 0 46H8V47H18Z"
            fill="var(--v2-bg-primary)"
          />
        </svg>
        {children}
        <svg
          className={clsx(
            "absolute top-0 right-0.5 translate-x-full group-hover:visible",
            {
              invisible: !isActive,
            },
          )}
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="47"
          viewBox="0 0 18 47"
          fill="none"
        >
          <path
            d="M0 47H10V46H18C13.582 46 10 42.418 10 38V10C10 4.47754 5.52246 0 0 0V47Z"
            fill="var(--v2-bg-primary)"
          />
        </svg>
      </>
    )}
  </NavLink>
);
